/**
 * 存储localStorage
 */
export const setStore = (name, content) => {
  if (!name) return
  if (typeof content !== 'string') {
    content = JSON.stringify(content)
  }
  window.localStorage.setItem(name, content)
}

/**
 * 获取localStorage
 */
export const getStore = name => {
  if (!name) return;
  let obj = window.localStorage.getItem(name);
  switch(name) {
    case "userInfo":
      return JSON.parse(localStorage.getItem(name)||'{}');
    case "buyCart":
      return JSON.parse(localStorage.getItem(name)||'[]');

    default:
      return obj; 
  }
}

/**
 * 删除localStorage
 */
export const removeStore = name => {
  if (!name) return
  window.localStorage.removeItem(name)
}



// WEBPACK FOOTER //
// ./src/utils/storage.js